// Pure helpers for the ticket list. No React (TSS vite/01 §"Feature folder shape").

// Newest draw first. Tickets arrive newest-first from the provider, so each
// group preserves purchase order inside a draw.
export function groupBySlot(tickets) {
    const bySlot = new Map();

    for (const ticket of tickets) {
        const group = bySlot.get(ticket.slotIndex);
        if (group) group.push(ticket);
        else bySlot.set(ticket.slotIndex, [ticket]);
    }

    return [...bySlot.entries()]
        .sort(([left], [right]) => right - left)
        .map(([slotIndex, items]) => ({ slotIndex, items }));
}
